import React, { useEffect } from "react";
import clsx from "clsx";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import FormHelperText from "@material-ui/core/FormHelperText";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import DGAlert from "../../component/alert";
import Button from "@material-ui/core/Button";
import { isMobile } from "react-device-detect";
import { api } from "../../api";
import Layout from "../../container/layout";
import EventHeader from "../../container/event/header";
import { useNavigate, useParams } from "react-router-dom";
import { initPage } from "../home/action";
import { inituser, login } from "./action";
import moment from "moment";
import { dateTH } from "../../utils";

const useStyles = makeStyles((theme) => ({
  bg: {
    backgroundImage: "url('/photo/bg.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center bottom",
    [theme.breakpoints.up("xs")]: {
      padding: 16,
    },
    [theme.breakpoints.down("xs")]: {
      backgroundImage: "none",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  loginDesc: {
    color: "#585251",
    fontSize: 18,
    padding: "16px 16px 0 16px",
    lineHeight: "32px",
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
    },
  },
  loginTime: {
    fontSize: 18,
    color: "#C92028",
    paddingBottom: 32,
    fontWeight: 501,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
    },
  },
  mainLogin: {
    maxWidth: 953,
    margin: "0 auto",
    border: "1px solid #EFEFEF",
    textAlign: "center",
    padding: "50px 0 64px 0",
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
    },
    [theme.breakpoints.up("xs")]: {
      marginTop: 30,
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: 0,
    },
  },
  button: {
    marginTop: 80,
    width: "404px",
    height: "70px",
    padding: 0,
    fontWeight: 500,
    fontSize: 24,
    lineHeight: "32px",
    [theme.breakpoints.down("xs")]: {
      fontSize: 18,
      lineHeight: "32px",
      width: "273px",
      height: "56px",
    },
  },
  banner: {
    [theme.breakpoints.down("sm")]: {
      paddingTop: 58,
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: 113.51,
    },
    width: "100%",
    maxWidth: 953,
    maxHeight: 250,
    objectFit: "cover",
    margin: "0 auto",
    color: "#000000",
    textAlign: "center",
    "& img": {
      width: "100%",
      maxWidth: 953,
      maxHeight: 250,
      objectFit: "cover",
    },
  },
  inputForm: {
    [theme.breakpoints.up("md")]: {
      padding: "32px 86px 32px 86px",
    },
  },
  errorText: {
    color: "#f44336",
  },
  content: {
    whiteSpace: "pre-wrap",
    fontSize: 18,
    lineHeight: "32px",
    color: "#585251",
    fontWeight: 400,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
    },
  },
  subtitlelogin: {
    fontSize: 18,
    lineHeight: "32px",
    color: "#585251",
    [theme.breakpoints.down("xs")]: {
      padding: "0 16px 0 16px",
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "32px",
    },
  },
  textheaderlogin: {
    [theme.breakpoints.down("xs")]: {
      padding: "0 16px 0 16px",
    },
  },
}));

const Login = () => {
  const navigate = useNavigate();

  const [values, setValues] = React.useState({
    username: "",
    password: "",
    showPassword: false,
  });

  const [state, setState] = React.useState({
    open: true,
    alert: false,
    error: {},
    errorText: {},
    snack: false,
    snackMsg: "",
    alertTitle: "",
    event: { banner_inside_mobile: [], banner_inside_desktop: [] },
  });

  const [start, setStart] = React.useState(true);

  const handleLogin = () => {
    const err = {
      username: !!!values.username,
      password: !!!values.password,
    };

    if (values.username === "" || values.password === "") {
      setState({
        ...state,
        error: err,
        open: false,
        alert: true,
        alertTitle: "ไม่สามารถเข้าสู่ระบบได้",
        errorText: {
          error: "กรุณากรอกข้อมูล Username และ Password",
        },
      });
    } else {
      login(values, state, setState, state.event.assetId, setStart, navigate);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSnackClose = () => {
    setState({ ...state, snack: false });
  };

  const alertConfirm = () => {
    setState({ ...state, alert: false });
  };

  const classes = useStyles();
  const { id } = useParams();

  useEffect(() => {
    initPage(state, setState, id, navigate);
  }, []);

  useEffect(() => {
    if (state.event?.assetId) {
      // if (
      //   moment(moment().format("YYYY-MM-DD"), "YYYY-MM-DD").isBefore(
      //     moment(state.event.startdate_at)
      //   )
      // ) {
      //   navigate("/notfound");
      // }
    }
  }, [state.event]);

  return (
    <div className={classes.bg}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={state.snack}
        onClose={handleSnackClose}
        message={state.snackMsg}
      />
      <Backdrop className={classes.backdrop} open={state.open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DGAlert
        title={!!state.alertTitle ? state.alertTitle : "แจ้งเตือน"}
        description={Object.keys(state.errorText).map((e, k) => (
          <div key={k}>{state.errorText[e]}</div>
        ))}
        open={state.alert}
        onConfirm={alertConfirm}
        labelConfirm="ปิด"
      />

      <div className={classes.banner}>
        <img
          src={
            isMobile
              ? `${process.env.REACT_APP_API_URL}/images/${
                  !!state.event?.banner_inside_mobile
                    ? state.event?.banner_inside_mobile[0]
                    : ""
                }`
              : `${process.env.REACT_APP_API_URL}/images/${
                  !!state.event?.banner_inside_desktop
                    ? state.event?.banner_inside_desktop[0]
                    : ""
                }`
          }
          alt=""
          width="100%"
        />
      </div>

      <Layout>
        <div
          className={classes.mainLogin}
          style={start ? {} : { border: "none" }}
        >
          <div className={classes.textheaderlogin}>
            <EventHeader
              title={state?.event?.assetName}
              description={state?.event?.des2}
              name={start ? "เข้าสู่ระบบ" : "ขณะนี้ยังไม่ถึงเวลาเริ่มกิจกรรม"}
            />
          </div>
          <div className={classes.loginDesc}>
            {!start ? (
              <>
                ท่านสามารถใช้ Username และ Password ในการทำแบบทดสอบได้
                <div className={classes.loginTime}>
                  ในวันที่ {dateTH(state.event?.examdate_at)} เวลา{" "}
                  {moment(state.event?.timestart_exam, "HH:mm:ss").format(
                    "H:mm"
                  )}
                  -
                  {moment(state.event?.timeend_exam, "HH:mm:ss").format("H:mm")}
                  น.
                </div>
                <div
                  className={classes.content}
                  dangerouslySetInnerHTML={{
                    __html: state.event.despolicystart,
                  }}
                />
              </>
            ) : (
              <div className={classes.subtitlelogin}>
                กรุณาเข้าสู่ระบบโดย Username และ Password
                ที่ได้รับจากอีเมล์ที่ท่านได้ลงทะเบียนไว้
              </div>
            )}
          </div>

          <form
            noValidate
            className={classes.inputForm}
            style={{
              marginTop: 16,
              display: start ? "block" : "none",
            }}
            autoComplete="off"
          >
            <TextField
              fullWidth
              placeholder="Username"
              value={values.username}
              id="standard-error"
              label="Username"
              margin="normal"
              onChange={handleChange("username")}
              style={{ maxWidth: 500, padding: 8, boxSizing: "border-box" }}
              InputLabelProps={{
                style: {
                  padding: 8,
                  fontWeight: 800,
                  fontSize: 18,
                  transform: "none",
                  color: "#292726",
                },
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  marginTop: 32,
                  marginBottom: 16,
                  fontSize: 18,
                  color: "#989898",
                  borderBottom: "1px solid #dddddd",
                },
              }}
              error={state.error.username}
              helperText={state.error.username ? `กรุณาระบุ Username` : ""}
            />

            <FormControl
              style={{
                padding: 8,
                maxWidth: 500,
                boxSizing: "border-box",
                marginTop: 32,
              }}
              fullWidth
            >
              <div
                style={{
                  marginTop: -32,
                  fontSize: 18,
                  textAlign: "left",
                  color: "#292726",
                }}
                shrink={false}
                htmlFor="outlined-adornment-password"
              >
                Password
              </div>
              <Input
                type={values.showPassword ? "text" : "password"}
                placeholder="Password"
                value={values.password}
                onChange={handleChange("password")}
                disableUnderline
                style={{
                  marginTop: 16,
                  marginBottom: 16,
                  fontSize: 18,
                  color: "#989898",
                  borderBottom: "1px solid #dddddd",
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                labelWidth={70}
              />
              {state.error.password && (
                <FormHelperText className={classes.errorText}>
                  {state.error.password ? `กรุณาระบุ Password` : ""}
                </FormHelperText>
              )}
            </FormControl>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={handleLogin}
              >
                เข้าสู่ระบบ
              </Button>
            </Grid>
          </form>
        </div>
      </Layout>
    </div>
  );
};

export default Login;
